import { Component, Input } from '@angular/core';
import { GenericListEntity, BaseEntity } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { EnumPageDisplayModes, EnumPageEntitySources } from '@core/framework/sysenums.enum';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';

class State {
     Value: any;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-selectboxdialog',
    templateUrl: './selectboxdialog.component.html',
    styleUrls: ['./selectboxdialog.component.scss']
})
export class SelectBoxDialogComponent extends BasePageComponent<BaseEntity, State> {
    @Input() Values: GenericListEntity[];
    @Input() FieldLabel: string;
    @Input() Title: string = this.GetTitle();
    @Input() Prompt: string;

    constructor(A: ServiceBagService) {
        super(A, 'SelectBoxDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    override OnInitTitle() {
        return this.Title;
    }

    override GetTitle() {
        const moduleName = this.GetFirstModuleName();
        return this.A.ResourcesService.RC('AppTitles.Messages', moduleName);
    }
}
